module.exports = __webpack_public_path__ + "components/rewards/insurance/static/logo-2ee6b52d751b96fb2b0ecbb446504730.webp";